import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';

import WelcomeLogo from "../../icons/WelcomeLogo";

interface WelcomeSectionProps {
    title?: string;
    subtitle?: string;
    showLogo?: boolean;
}

export const WelcomeSection: React.FC<WelcomeSectionProps> = ({
    title = "Welcome to your RCM AI Assistant",
    subtitle = "Upload claims and medical records, ask policy questions, or generate appeal letters to get started.",
    showLogo
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 4,
                mt: 2,
            }}
        >
            {showLogo ? <WelcomeLogo /> : null}

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1,
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        textAlign: 'center',
                        fontWeight: 800,
                        backgroundImage: 'linear-gradient(87.38deg, #272366 0.42%, #9158CE 100%)',
                        color: 'transparent',
                        backgroundClip: 'text',
                    }}
                >
                    {title}
                </Typography>
                
                <Typography
                    variant="body1"
                    sx={{
                        color: 'text.secondary',
                        textAlign: 'center',
                        fontWeight: 500,
                        maxWidth: '400px',
                    }}
                >
                    {subtitle}
                </Typography>
            </Box>
        </Box>
    );
};

export default memo(WelcomeSection);
